import { Stack } from "@mantine/core"

import { CommunicationMaterials } from "~/pages/Brand/CommunicationStudio/OrganizationGeneralSettings/components/CommunicationMaterials"
import { SubscriptionPlans } from "~/pages/Brand/CommunicationStudio/OrganizationGeneralSettings/components/SubscriptionPlans"

export const OrganizationGeneralSettings = () => (
  <Stack gap="xl">
    <SubscriptionPlans />
    <CommunicationMaterials />
  </Stack>
)
